import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ApplicationModule } from '@shared/utils';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class RouterUtilsService {
  private _activeModule = new BehaviorSubject<ApplicationModule | null>(null);

  setActiveModule(activeModule: ApplicationModule | null) {
    this._activeModule.next(activeModule);
  }

  getActiveModule() {
    return this._activeModule.asObservable();
  }
}
